const autoCompleteInitialItem = [];

export default autoCompleteInitialItem;
